/**
 * <ry-stat>
 *
 * KPI / statistic display with optional trend arrow.
 *
 * Usage:
 * <ry-stat value="2,847" label="Active Users" trend="up"></ry-stat>
 */

import { RyElement } from '../core/ry-element.js';
import { getIcon } from '../core/ry-icons.js';

export class RyStat extends RyElement {
  setup(): void {
    this.#transformMarkup();
  }

  #transformMarkup(): void {
    if (this.$('[data-ry-target="value"]')) return;

    const valueText = this.getAttribute('value') ?? '';
    const labelText = this.getAttribute('label') ?? '';
    const trend = this.getAttribute('trend');

    const trendIcon = trend === 'up'
      ? `<span data-ry-target="trend" class="ry-stat__trend ry-stat__trend--up">${getIcon('chevron-up')}</span>`
      : trend === 'down'
        ? `<span data-ry-target="trend" class="ry-stat__trend ry-stat__trend--down">${getIcon('chevron-down')}</span>`
        : '';

    this.innerHTML = `
      <div data-ry-target="value" class="ry-stat__value">${valueText}${trendIcon}</div>
      <div data-ry-target="label" class="ry-stat__label">${labelText}</div>
    `;
  }
}

customElements.define('ry-stat', RyStat);
